/* eslint-disable no-unused-vars, no-undef */

/*
 * @author Sanford Whiteman
 * @version v1.106 2020-04-04
 * @copyright © 2020 Sanford Whiteman
 * @license Hippocratic 2.1: This license must appear with all reproductions of this software.
 * https://codepen.io/figureone/pen/dLqxPG
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
function destyleMktoForm (mktoForm, moreStyles) {
	let form = mktoForm.getFormElem()[0],
		arrayify = getSelection.call.bind([].slice);

	// remove element styles from <form> and children
	let styledEls = arrayify(form.querySelectorAll('[style]')).concat(form);
	styledEls.forEach(function (el) {
		el.removeAttribute('style');
	});

	// disable remote stylesheets and local <style>s
	let styleSheets = arrayify(document.styleSheets);
	styleSheets.forEach(function (ss) {
		if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || form.contains(ss.ownerNode)) {
			//console.log('Marketo destyle: removing', ss);
			ss.disabled = true;
		} else {
			// console.log('Marketo destyle: ignoring', ss);
		}
	});
	if (!moreStyles) {
		form.setAttribute('data-styles-ready', 'true');
	}
}

function addRowClasses (mktoForm) {
	let form = mktoForm.getFormElem()[0],
		rows = form.querySelectorAll('.mktoFormRow');
	if (!rows.length) return;
	for (let row of rows) {
		if (!row.querySelector('textarea')) continue;
		row.classList.add('has-textarea');
	}
}

function addWrapClasses (mktoForm) {
	let form = mktoForm.getFormElem()[0],
		wraps = form.querySelectorAll('.mktoFieldWrap');
	if (!wraps.length) return;
	for (let wrap of wraps) {
		if (!wrap.querySelector('input[type="checkbox"]')) continue;
		wrap.classList.add('has-checkbox');
	}
}

// display confirmation message instead of redirecting if data-mkto-conf attribute is present on form wrapper
function confirmationMessage (mktoForm) {
	let formEl = mktoForm.getFormElem()[0],
		conf = formEl.getAttribute('data-mkto-conf');
	if (!conf) return;
	let confEl = document.createElement('p');
	confEl.innerHTML = conf;

	mktoForm.onSuccess(function (values, followUpUrl) {
		formEl.parentNode.replaceChild(confEl, formEl);
		return false;
	});
}

// adapted from https://nation.marketo.com/t5/product-discussions/pulling-field-from-one-form-to-another/m-p/199967/highlight/true#M145612
function populateFromHash (mktoForm) {
	const hash = document.location.hash.substring(1);
	if (!hash) return;
	const fields = JSON.parse(decodeURIComponent(hash));
	mktoForm.setValues(fields);
}

// adapted from https://codepen.io/figureone/pen/ayKadR
function mktoFormChain (
	config = {
		path: '//s.sermo.com',
		munchkinId: '239-PZX-356'
	}
) {
	let attr = 'data-mkto-instance',
		formEls = document.querySelectorAll('[' + attr + ']'),
		mktoIds = [],
		arrayify = getSelection.call.bind([].slice);

	if (!formEls.length) return;

	for (let formEl of formEls) {
		let mktoId = parseInt(formEl.getAttribute(attr));
		if (mktoIds.includes(mktoId)) continue;
		mktoIds.push(mktoId);
	}

	if (!mktoIds.length) return;

	MktoForms2.whenRendered(function (mktoForm) {
		let formEl = mktoForm.getFormElem()[0],
			rando = "_" + new Date().getTime() + Math.random();

		if (!mktoIds.includes(mktoForm.getId())) return;

		arrayify(formEl.querySelectorAll('label[for]'))
			.map(function (labelEl) {
				return {
					label: labelEl,
					for: formEl.querySelector('[id="' + labelEl.htmlFor + '"]')
				}
			})
			.forEach(function (labelObj) {
				if (labelObj.for) {
					if (!labelObj.for.hasAttribute('data-uniquified')) {
						labelObj.for.id = labelObj.for.id + rando;
						labelObj.for.setAttribute('data-uniquified', 'true');
					}
					labelObj.label.htmlFor = labelObj.for.id;
				}
			});
	});

	// chain, ensuring only one #mktoForm_nnn exists at a time
	arrayify(mktoIds).forEach(function (mktoId) {
		let loadForm = MktoForms2.loadForm.bind(MktoForms2, config.path, config.munchkinId, mktoId),
			formEls = arrayify(document.querySelectorAll('[' + attr + '="' + mktoId + '"]'));

		(function loadFormCb (formEls) {
			var formEl = formEls.shift();
			formEl.id = 'mktoForm_' + mktoId;

			loadForm(function (mktoForm) {
				formEl.id = '';
				if (formEls.length) {
					loadFormCb(formEls);
				}
			});
		})(formEls);
	});
}

// helper function for businessEmail
function isAllowedEmail (email, disallowed) {
	for (let d of disallowed) {
		if (email.includes(d)) return false;
	}
	return true;
}
// adapted from https://codepen.io/figureone/pen/zYovRrK/85b9839557e2b684cc22a2b552a67bcb?editors=1010
function restrictFieldValue(mktoId = false, disallowed = [], invalidMsg = 'Must be a business email address.', field = 'Email') {
	if (!mktoId || !disallowed.length) return;
	MktoForms2.whenReady(function (mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		mktoForm.onValidate(function (nativeValid) {
			if (!nativeValid) return;

			mktoForm.submittable(true);
		});
	});

	MktoForms2.whenReady(function (mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		const formEl = mktoForm.getFormElem()[0],
			emailEl = formEl.querySelector('[name="' + field + '"]');

		mktoForm.onValidate(function (nativeValid) {
			if (!nativeValid || !mktoForm.submittable()) return;

			let currentValues = mktoForm.getValues(),
				originalSubmittable = mktoForm.submittable(),
				email = currentValues[field];

			mktoForm.submittable(false);

			if (email) {
				// if (!FormsPlus.emailPattern.match(email, disallowed)) {
				if (isAllowedEmail(email, disallowed)) {
					console.log('Email meets requirements, continuing');
					emailEl.classList.remove('customInvalid');
					emailEl.setAttribute('aria-invalid', 'false');
					mktoForm.submittable(true);
				} else {
					console.log('Email does not meet requirements, forcing submittable(false)');
					emailEl.classList.add('customInvalid');
					emailEl.setAttribute('aria-invalid', 'true');
					mktoForm.showErrorMessage(invalidMsg, MktoForms2.$(emailEl));
				}
			}
		});
	});
}

// adapted from https://codepen.io/figureone/pen/GRPgrzw?editors=1010&ref=blog.teknkl.com
// with marketo fields from this video: https://blog.teknkl.com/coming-to-you-live-how-to-correctly-integrate-recaptcha-v3-into-marketo-forms/
function mktoRecaptcha (
	mktoId,
	recaptchaConfig = {
		apiKeys: {
			recaptcha: "6Lc4XTcrAAAAAD4QVsMQLunA7H0FAjSaKwk9mL4_"
		},
		fields: {
			recaptchaFinger: "reCAPTCHALastUserFingerprint"
		},
		actions: {
			formSubmit: "form"
		},
		debug: {
			testBadFinger: false
		}
	}
) {
	MktoForms2.whenReady(function (mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		let formEl = mktoForm.getFormElem()[0],
			submitButtonEl = formEl.querySelector("button[type='submit']");

		// pending reCAPTCHA widget ready
		submitButtonEl.disabled = true;

		// pending reCAPTCHA verify
		mktoForm.submittable(false);
		mktoForm.locked = false;

		mktoForm.onValidate(function (native) {
			if (!native) return;

			grecaptcha.ready(function () {
				grecaptcha.execute(recaptchaConfig.apiKeys.recaptcha, {
					action: recaptchaConfig.actions.formSubmit
				})
					.then(function (recaptchaFinger) {
						let mktoFields = {};
						if (mktoForm.locked == false) {
							console.log("primary recaptcha response resolved");
							mktoForm.locked = true;
							// mktoFields[recaptchaConfig.fields.recaptchaFinger] = recaptchaFinger;
							if (!recaptchaConfig.debug.testBadFinger) {
								mktoFields[recaptchaConfig.fields.recaptchaFinger] = recaptchaFinger;
							} else {
								mktoFields[recaptchaConfig.fields.recaptchaFinger] = "known bad fingerprint " + Math.random();
							}
							mktoForm.addHiddenFields(mktoFields);
							mktoForm.submittable(true);
							mktoForm.submit();
						} else {
							console.log("secondary recaptcha response resolved");
						}
					});
			});
		});
	});

	let recaptchaListeners = {
		ready: function () {
			MktoForms2.whenReady(function (mktoForm) {
				if (mktoForm.getId() !== mktoId) return;
				let formEl = mktoForm.getFormElem()[0],
					submitButtonEl = formEl.querySelector("button[type='submit']");

				submitButtonEl.disabled = false;
			});
		}
	};
	Object.keys(recaptchaListeners).forEach(function globalize (fnName) {
		window["grecaptchaListeners_" + fnName] = recaptchaListeners[fnName];
	});

	// inject the reCAPTCHA library
	let recaptchaLib = document.createElement("script");
	recaptchaLib.src = "https://www.google.com/recaptcha/api.js?render=" + recaptchaConfig.apiKeys.recaptcha + "&onload=grecaptchaListeners_ready";
	document.head.appendChild(recaptchaLib);
}

/* eslint-enable no-unused-vars, no-undef */

export {
	// config,
	// arrayify,
	destyleMktoForm,
	addRowClasses,
	addWrapClasses,
	confirmationMessage,
	populateFromHash,
	mktoFormChain,
	restrictFieldValue,
	// recaptchaConfig,
	mktoRecaptcha
};
